import { canv } from '@/canv/global.js'
import { sleep, getTarget } from '@/canv/utils.js'

export class shortcutsWindow {

    constructor() {

    }


    async show() {

        const shortcutsWindowWrapper = document.createElement('div');
        shortcutsWindowWrapper.classList.add("shortcutsWindowWrapper");
        document.body.prepend(shortcutsWindowWrapper);

        shortcutsWindowWrapper.innerHTML += this.getMenu();

        const shortcutsWindowContent = document.getElementsByClassName("shortcutsWindowContent")[0];
        const actionSymbol = canv.actionManager.actionSymbol;
        const altSymbol = canv.actionManager.altSymbol;

        shortcutsWindowContent.innerHTML += this.sectionTitleTemplate("Инструменты");
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Выбор", ["V"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Перо", ["P"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Ластик", ["E"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Фигура", ["S"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Стикер", ["N"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Текст", ["T"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Линия/стрелка", ["L"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Комментарий", ["C"]);
        shortcutsWindowContent.innerHTML += this.sectionTitleTemplate("Редактирование");
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Шаг назад", [actionSymbol, "Z"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Шаг вперед", [actionSymbol, "Shift", "Z"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Скопировать", [actionSymbol, "C"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Вставить", [actionSymbol, "V"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Дублировать", [actionSymbol, "D"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Дублировать", [altSymbol, "Перетащить"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Сгруппировать", [actionSymbol, "G"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Разгруппировать", [actionSymbol, "Shift", "G"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Переместить вперед", [actionSymbol, "]"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Переместить назад", [actionSymbol, "["]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Удалить", ["Backspace"]);


        shortcutsWindowContent.innerHTML += this.sectionTitleTemplate("Навигация");
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Выбрать все", [actionSymbol, "A"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Приблизить", [actionSymbol, "+"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Отдалить", [actionSymbol, "-"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Поиск", [actionSymbol, "F"]);

        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Масштаб в 100%", [actionSymbol, "0"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Масштаб с учетом всего содержимого", [altSymbol, "1"]);
        shortcutsWindowContent.innerHTML += this.applyShortcutTemplate("Масштаб с учетом выбранных элементов", [altSymbol, "2"]);


        await sleep(50);
        shortcutsWindowWrapper.style.opacity = "1";
        this.init();
    }



    init() {
        var shortcutsWindowWrapper = document.getElementsByClassName("shortcutsWindowWrapper")[0];
        shortcutsWindowWrapper.addEventListener('mousedown', this.wrapperClick.bind(this), false);
    }

    hide() {
        var accountSettings = document.getElementsByClassName("shortcutsWindowWrapper")[0];
        if (accountSettings != undefined) {
            accountSettings.outerHTML = "";
        }
    }



    // Proccessors

    wrapperClick(e) {
        var tryInner = getTarget(e, "shortcutsWindow");
        if (tryInner == null) {
            this.hide();
        }
    }






    // Templates

    getMenu() {

        var template = `
            <div class="shortcutsWindow">
                <div class="shortcutsWindowUp">
                    <p class="shortcutsWindowUpTitle">Горячие клавиши</p>
                </div>
                <div class="shortcutsWindowContent scrollable">
                </div>
            </div>
        `;

        return template;
    }

    applyShortcutTemplate(action, buttonsList) {

        var buttons = ``;

        for (var i = 0; i < buttonsList.length; i++) {
            buttons += `<div class="shortcutsWindowContentItemBoxItem">` + buttonsList[i] + `</div>`;
        }

        var template = `
            <div class="shortcutsWindowContentItem">
                <p class="shortcutsWindowContentItemTitle">` + action + `</p>
                <div class="shortcutsWindowContentItemSpacer"></div>
                <div class="shortcutsWindowContentItemBox">
                    ` + buttons + `
                </div>
            </div>
        `;

        return template;
    }

    sectionTitleTemplate(title) {
        return `
            <div class="shortcutsWindowContentItemSection">` + title + `</div>
        `;
    }


}
